import { useMutation } from 'react-query';
import { DrmPage } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { useDrmPageToParams } from '../models';

type Entity = Record<string, unknown>;

interface useFieldMutationProps {
  drmPage: DrmPage;
  entity: Entity;
  onUpdate: (entity: Entity) => void;
  onSuccess?: () => void;
  onError?: () => void;
  fieldName: string;
}

export default function useFieldMutation({
  fieldName,
  drmPage,
  entity,
  onUpdate,
  onSuccess,
  onError,
}: useFieldMutationProps) {
  const drmPageToParams = useDrmPageToParams();
  const { endpoint } = drmPageToParams[drmPage];

  const mutation = useMutation(
    ['useFieldMutation', drmPage, entity],
    async (fieldValueUpdate: string | boolean | number) => {
      return await restFactory.patch<Entity>(
        `/dj/api/v1/${endpoint}/${entity.id}/`,
        { [fieldName]: String(fieldValueUpdate) || null }
      );
    },
    {
      onSuccess: (updatedEntity: Entity) => {
        onUpdate(updatedEntity);
        onSuccess?.();
      },
      onError,
    }
  );

  return mutation;
}
